import React, { useState } from 'react';
import { Button, Modal, Form, Input } from 'antd';
import {UserAddOutlined} from '@ant-design/icons';

const CustomerAddForm = ({ visible, onCreate, onCancel }) => {

  const [form] = Form.useForm();

  return (
    <Modal
      visible={visible}
      title="Create a new collection"
      okText="Create"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}

    >
      <Form
        form={form}
        layout="vertical"
        name="CustomerForm"
        initialValues={{
          CustomerName:'',
          CustomerAddress:'',
          CustomerEmail:'',
          CustomerPhone:'',
      }}
      >
        <Form.Item name="CustomerName" label="Customer Name">
          <Input />
        </Form.Item>
        <Form.Item name="CustomerAddress" label="Customer Address">
          <Input />
        </Form.Item>
        
        <Form.Item 
        name='CustomerEmail' 
        label="Customer Email" 
        rules={[
          {type: 'email',message: 'The input is not valid E-mail!',},
          { required: true, message: 'Please input your Email!' }]}
        >
            <Input />
        </Form.Item>
        <Form.Item 
          name='CustomerPhone' 
          label="Customer Phone"
          validateTrigger='onBlur'
          rules={[
            {
              required:false,
              pattern: new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, "g"),
              message:'Please enter the correct format'
            }
          ]}
        >
            <Input addonBefore={'+1'}/>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const CustomerAdd = ( props) => {

  const [visible, setVisible] = useState(false);
  const onCreate = (values) => {
    props.addCustomer(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}
        icon={<UserAddOutlined />}
      >
        Add Customer
      </Button>
      <CustomerAddForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </div>
  );
};

export default CustomerAdd